import React, { Component } from 'react'
import { Main, MainBody, MainTop, MainTopLeft, MainTopTitle } from '@/components/Layout'
import Resx from '@/components/Resx'
import { Detail as UserInfo, RolesBox } from '@/components/usersManagement'
import { actionCreators } from '@/store/usersManagement'
import { localized } from '@/decorators/localized'
import { connect } from 'react-redux'
import LoadingIndicator from '@/components/LoadingIndicator'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { Button } from '@/components/button'
import { Row, Col } from 'reactstrap'
import { ResetPasswordButton } from '@/components/usersManagement/resetPasswordButton'

const mapStateToProps = (state) => {
  return {
    userFetching: state.usersManagement.userFetching,
    userFetched: state.usersManagement.userFetched,
    user: state.usersManagement.user
  }
}

const mapDispatchToProps = {
  openDialog: dialogActions.openDialog,
  getUser: actionCreators.getUser,
  setUserState: actionCreators.setUserState,
  generatePasswordResetToken: actionCreators.generatePasswordResetToken
}

@localized()
@connect(mapStateToProps, mapDispatchToProps)
class Detail extends Component {
  componentDidMount () {
    const { id } = this.props.match.params

    if (id) {
      this.props.getUser(id)
    }
  }

  setUserState = () => {
    const { user } = this.props
    this.props.setUserState({
      id: user.id,
      stateCode: 'BlockOrActivate'
    }, true)
  }

  generatePasswordResetToken = () => {
    const { user } = this.props
    this.props.generatePasswordResetToken(user.emailAddress)
  }

  getButtons (user) {
    if (user.approvedAt !== null) {
      return (<React.Fragment>
        <Button
          key='blockActivateButton'
          color='primary'
          className='btn btn-sm btn-primary'
          onClick={this.setUserState}
          confirmTitle={user.isActive ? 'UsersManagement.SetInactiveConfirmTitle' : 'UsersManagement.SetActiveConfirmTitle'}
          confirmText={user.isActive ? 'UsersManagement.SetInactiveConfirmText' : 'UsersManagement.SetActiveConfirmText'}
          icon={user.isActive ? 'lock-open' : 'lock'}>
          <Resx name='UsersManagement.Activate' />
        </Button>
        <ResetPasswordButton onClick={this.generatePasswordResetToken} user={user} openDialog={this.props.openDialog} />
      </React.Fragment>)
    }
  }

  renderRoles () {
    const { user } = this.props

    if (user.id) {
      return (
        <React.Fragment>
          <Col lg='6'>
            <RolesBox userId={user.id} simpleView />
          </Col>
        </React.Fragment>
      )
    }
  }

  render () {
    const { user, userFetched } = this.props

    return (
      <Main path={[user.userName && { text: user.userName, localized: true }]}>
        <MainTop>
          <MainTopTitle backUrl='/users'>
            <Resx name='UsersManagement.Detail' />
          </MainTopTitle>
          <MainTopLeft>
            {this.getButtons(user)}
          </MainTopLeft>
        </MainTop>
        <MainBody clear>
          {!userFetched
            ? <LoadingIndicator />
            : <UserInfo user={user} canEditLegacyCode />
          }
          <Row>
            {this.renderRoles()}
          </Row>
        </MainBody>
      </Main>
    )
  }
}

export default Detail



// WEBPACK FOOTER //
// ./src/report-app/pages/usersManagement/detail.js